export const myCommunity = {
  // Page titles and navigation
  'backoffice.myCommunity.genealogyTreeTitle': 'My Genealogy Tree',
  'backoffice.myCommunity.organizationalChart': 'Organizational Chart',
  'backoffice.myCommunity.treeViewTitle': 'Tree View',
  'backoffice.myCommunity.membersTitle': 'Community Members',
  'backoffice.myCommunity.genealogyTreeSubtitle': 'Explore your complete referral hierarchy',
  'backoffice.myCommunity.treeViewSubtitle': 'Table view of your Community',
  'backoffice.myCommunity.membersSubtitle': 'List of all your direct and indirect referrals',

  // Common labels
  'backoffice.myCommunity.username': 'Username',
  'backoffice.myCommunity.status': 'Status',
  'backoffice.myCommunity.rank': 'Rank',
  'backoffice.myCommunity.level': 'Level',
  'backoffice.myCommunity.joinDate': 'Join Date',
  'backoffice.myCommunity.country': 'Country',
  'backoffice.myCommunity.active': 'Active',
  'backoffice.myCommunity.inactive': 'Inactive',
  'backoffice.myCommunity.loading': 'Loading...',
  'backoffice.myCommunity.loadMore': 'Load More',
  'backoffice.myCommunity.expand': 'Expand',
  'backoffice.myCommunity.collapse': 'Collapse',
  'backoffice.myCommunity.resetView': 'Reset View',
  'backoffice.myCommunity.memberSince': 'Member since',
  'backoffice.myCommunity.comingSoon': 'Coming Soon...',

  // Tree specific
  'backoffice.myCommunity.directReferrals': 'Direct Referrals',
  'backoffice.myCommunity.treeLevel': 'Tree Level',
  'backoffice.myCommunity.zoomIn': 'Zoom In',
  'backoffice.myCommunity.zoomOut': 'Zoom Out',
  
  // Members specific
  'backoffice.myCommunity.totalUsers': 'Total Users',
  'backoffice.myCommunity.activeUsers': 'Active Users',
  'backoffice.myCommunity.inactiveUsers': 'Inactive Users',
  'backoffice.myCommunity.levelStats': 'Level {level} Statistics',
  'backoffice.myCommunity.yourProfile': 'Your Profile',
  'backoffice.myCommunity.communityMembers': 'Community Members',
  
  // Filters
  'backoffice.myCommunity.filterByLevel': 'Filter by Level',
  'backoffice.myCommunity.filterByStatus': 'Filter by Status',
  'backoffice.myCommunity.allLevels': 'All Levels',
  'backoffice.myCommunity.allStatuses': 'All Statuses',
  
  // Error messages
  'backoffice.myCommunity.noDataFound': 'No community data found',
  'backoffice.myCommunity.errorLoading': 'Error loading community data',
  'backoffice.myCommunity.tryAgain': 'Try Again',

  // Table column headers - updated keys
  'backoffice.myCommunity.tableColumns.username': 'Username',
  'backoffice.myCommunity.tableColumns.name': 'Name',
  'backoffice.myCommunity.tableColumns.status': 'Status',
  'backoffice.myCommunity.tableColumns.rank': 'Rank',
  'backoffice.myCommunity.tableColumns.level': 'Level',
  'backoffice.myCommunity.tableColumns.joinDate': 'Join Date',
  'backoffice.myCommunity.tableColumns.country': 'Country',
};
